import { render, staticRenderFns } from "./PaymentMethodSettings.vue?vue&type=template&id=32333576"
import script from "./PaymentMethodSettings.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports